import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import MenuIcon from "sweet-web/components/icons/MenuIcon";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { toggleMenu } from "sweet-web/redux/app/actions";

const Button = styled.button`
  outline: none;
  border: none;
  background: transparent;
  padding: 10px 5px;
  margin-top: 3px;
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

type Props = ConnectedProps<typeof connector>;

const OpenButton: React.FC<Props> = props => {
  return (
    <Button onClick={() => props.toggleMenu(true)}>
      <MenuIcon size={24} color={colors.primary} />
    </Button>
  );
};

const mapState = (state: RootState) => ({});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      toggleMenu
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(OpenButton);
